
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FondoDiagonal',
  props: {
    inicio: {
      type: Boolean,
      default: false
    }
  }
});
